module.exports = __webpack_public_path__ + "static/media/search.735a128b.png";